// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
  }
  
  /* Demo only */
  body {
    background: #f1f1f1;
    margin: 0;
    font-family: Arial, Helvetica, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  .selected-item {
    text-align: center;
  }
  
  .controls-container {
    --highlight-width: auto;
    --highlight-x-pos: 0;
  
    display: flex;
    margin: 0px 0 20px;
  }
  
  .controls {
    display: inline-flex;
    justify-content: space-between;
    background: #53534c;
    box-shadow: 0 0 3px 1px white;
    border-radius: 10px;
    max-width: 500px;
    padding: 2px;
    margin: auto;
    overflow: hidden;
    position: relative;
  }
  
  .controls input {
    opacity: 0;
    margin: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    position: absolute;
    width: 100%;
    cursor: pointer;
    height: 100%;
  }
  
  .segment {
    /* width: 100%; uncomment for each segment to have matching width */
    min-width: 120px; /* min-width: 0px; */
    position: relative;
    text-align: center;
    z-index: 1;
  }
  
  .segment label {
    cursor: pointer;
    display: block;
    font-weight: 0;
    padding: 10px;
    transition: color 0.5s ease;
  }
  
  .segment.active label {
    color: #fff;
  }
  
  .controls::before {
    content: "";
    background: #c98c3c;
    border-radius: 8px;
    width: var(--highlight-width);
    transform: translateX(var(--highlight-x-pos));
    position: absolute;
    top: 2px;
    bottom: 2px;
    left: 0;
    z-index: 0;
  }
  
  /* Only allow transitions once component is ready */
  .controls.ready::before {
    transition: transform 0.3s ease, width 0.3s ease;
  }
  `, "",{"version":3,"sources":["webpack://./src/Segstyles.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;EACxB;;EAEA,cAAc;EACd;IACE,mBAAmB;IACnB,SAAS;IACT,yCAAyC;IACzC,mCAAmC;IACnC,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,oBAAoB;;IAEpB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,8BAA8B;IAC9B,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,SAAS;IACT,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,YAAY;EACd;;EAEA;IACE,mEAAmE;IACnE,gBAAgB,EAAE,oBAAoB;IACtC,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,cAAc;IACd,cAAc;IACd,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,6CAA6C;IAC7C,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,OAAO;IACP,UAAU;EACZ;;EAEA,mDAAmD;EACnD;IACE,gDAAgD;EAClD","sourcesContent":["* {\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n  /* Demo only */\r\n  body {\r\n    background: #f1f1f1;\r\n    margin: 0;\r\n    font-family: Arial, Helvetica, sans-serif;\r\n    -webkit-font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\r\n  }\r\n  \r\n  .selected-item {\r\n    text-align: center;\r\n  }\r\n  \r\n  .controls-container {\r\n    --highlight-width: auto;\r\n    --highlight-x-pos: 0;\r\n  \r\n    display: flex;\r\n    margin: 0px 0 20px;\r\n  }\r\n  \r\n  .controls {\r\n    display: inline-flex;\r\n    justify-content: space-between;\r\n    background: #53534c;\r\n    box-shadow: 0 0 3px 1px white;\r\n    border-radius: 10px;\r\n    max-width: 500px;\r\n    padding: 2px;\r\n    margin: auto;\r\n    overflow: hidden;\r\n    position: relative;\r\n  }\r\n  \r\n  .controls input {\r\n    opacity: 0;\r\n    margin: 0;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    position: absolute;\r\n    width: 100%;\r\n    cursor: pointer;\r\n    height: 100%;\r\n  }\r\n  \r\n  .segment {\r\n    /* width: 100%; uncomment for each segment to have matching width */\r\n    min-width: 120px; /* min-width: 0px; */\r\n    position: relative;\r\n    text-align: center;\r\n    z-index: 1;\r\n  }\r\n  \r\n  .segment label {\r\n    cursor: pointer;\r\n    display: block;\r\n    font-weight: 0;\r\n    padding: 10px;\r\n    transition: color 0.5s ease;\r\n  }\r\n  \r\n  .segment.active label {\r\n    color: #fff;\r\n  }\r\n  \r\n  .controls::before {\r\n    content: \"\";\r\n    background: #c98c3c;\r\n    border-radius: 8px;\r\n    width: var(--highlight-width);\r\n    transform: translateX(var(--highlight-x-pos));\r\n    position: absolute;\r\n    top: 2px;\r\n    bottom: 2px;\r\n    left: 0;\r\n    z-index: 0;\r\n  }\r\n  \r\n  /* Only allow transitions once component is ready */\r\n  .controls.ready::before {\r\n    transition: transform 0.3s ease, width 0.3s ease;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
